import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=76f59026&scoped=true&"
import script from "./FlagIcon.vue?vue&type=script&lang=js&"
export * from "./FlagIcon.vue?vue&type=script&lang=js&"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=76f59026&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f59026",
  null
  
)

export default component.exports